export default `
<style>
.fbhr {
  max-width: 1000px;
  width: 100%;
  margin: 0 auto;
  padding: 3rem 1.5rem;
  font-family: "Roboto Condensed", sans-serif;
  font-size: 1rem;
  font-weight: normal;
  line-height: 1.875;
  color: var(--txt_color_3);
}

.fbhr h1 {
  font-size: 2.625rem;
  font-weight: bold;
  line-height: 1.3;
  letter-spacing: 0.25px;
  margin-bottom: 1.875rem;
}

.fbhr h2 {
  font-size: 2.063rem;
  font-weight: bold;
  line-height: 1.3;
  letter-spacing: 0.25px;
  margin-top: 3.75rem;
  margin-bottom: 1.875rem;
}

.fbhr a {
  text-decoration: underline;
}

.fbhr p,
.fbhr ul {
  margin-bottom: 1rem;
}

.fbhr ul {
  margin-left: 1.875rem;
}

.fbhr li {
  margin-bottom: 0.6rem;
}

.fbhr .showCookieManagementButton:hover {
    background: var(--btn_primary_bg_hover_1);
    color: var(--btn_primary_txt_hover_1);
}

.fbhr .showCookieManagementButton {
  cursor: pointer;
  text-decoration: underline;
  background: var(--btn_primary_bg_color_1);
  color: var(--btn_primary_txt_color_1);
  padding: var(--b-spacing-s) var(--b-spacing-m);
  height: 32px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  text-decoration: none;
  box-sizing: border-box;
  font-size: var(--b-font-size-m);
  line-height: var(--b-line-height-normal);
  font-family: var(--b-font-family-base);
  font-weight: var(--b-font-weight-bold);
  text-transform: uppercase;
  border-radius: var(--b-border-radius-xs);
  cursor: pointer;
  outline: none;
  border: none;
}
}

/* Extra large */
@media (min-width: 1200px) {
  html {
    font-size: 16px;
  }

  .fbhr {
    padding: 3rem 0;
  }
}

</style>

<div class="fbhr">
<h1 class="text-center">Politica cookie-uri</h1>
    <h2>Informatii despre Cookies</h2>
    <p>La accesarea serviciilor noastre, cu consimțământul dvs., putem stoca informații pe dispozitivul pe care-l folositi. Aceste informații sunt denumite cookie-uri, care sunt fișiere text mici care conțin litere și numere pentru a vă înregistra preferințele. Cookie-urile sunt stocate pe aparatul dvs. atunci când utilizați serviciile noastre în timp ce vizitați site-ul noastru <a href="https://www.favbet.ro">Favbet.ro</a> și paginile noastre online.</p>
    <p>De asemenea, folosim obiecte locale partajate sau "flash cookies". "Cookie-urile Flash" sunt similare cu cookie-urile din browser. Ele ne permit să ne amintim vizitele dvs. pe site-urile noastre.</p>
    <p>Nici cookie-urile, nici cookie-urile flash nu pot fi folosite pentru a accesa dispozitivul dvs. sau pentru a utiliza informații de pe computer.</p>
    <p>Utilizăm aceste metode numai pentru a urmări utilizarea serviciilor dvs. prin înregistrarea preferințelor dvs.</p>
    <p>Utilizăm cookie-uri flash și alte cookie-uri pentru a ne ajuta să vă afișăm reclame mai relevante și mai bine direcționate.</p>
    <p>Cookie-urile ne ajută să monitorizăm traficul pe site-ul nostru, să îmbunătățim serviciile noastre, să vă faciliteze accesul la ele și să vă sporiți interesul pentru aceste servicii.</p>
    <p>Utilizăm numai cookie-uri și cookie-uri flash pentru monitorizare.</p>
    <h2>De ce folosim Cookies</h2>
    <p>Cookie-urile sunt strict necesare, acestea sunt folosite pentru a permite utilizatorilor să navigheze pe site și să utilizeze funcțiile sale, cum ar fi accesarea zonelor protejate ale site-ului sau efectuarea de tranzacții financiare. Fără aceste cookie-uri, nu veți putea să utilizați eficient site-urile si produsele noastre.</p>
    <p>Aceste cookie-uri vor conține informațiile colectate în timpul înregistrării și ne vor permite să vă recunoaștem ca client și să vă furnizăm serviciile pe care le solicitați. Putem, de asemenea, utiliza aceste date pentru a înțelege mai bine interesele și preferințele dvs. online și pentru a îmbunătăți în mod constant vizitele dvs. pe platformele noastre și utilizarea serviciilor noastre.</p>
    <p>Utilizăm modulele cookie pentru a colecta informații pentru vizitatorii site-ului nostru.</p>
    <p>Cookie-urile ne permit să recunoaștem și să numărăm numărul de vizitatori pe site-ul nostru și să vedem cum utilizează vizitatorii conținutul și serviciile noastre. Acest lucru ne ajută să îmbunătățim modul în care site-ul noastru funcționează.</p>
    <p>Luați o decizie și aveți întotdeauna posibilitatea de a alege sau de a refuza cookie-urile.</p>
    <p>Majoritatea browserelor web acceptă automat cookie-urile, dar, dacă preferați, puteți modifica setările browserului pentru a vă gestiona fișierele cookie.</p>
    <p>Puteți utiliza browserul web pentru a:</p>
    <ul>
        <li>șterge toate cookie-urile;</li>
        <li>bloca toate cookie-urile;</li>
        <li>permite toate modulele de cookie;</li>
        <li>bloca modulele de cookie ale unei terțe parti;</li>
        <li>șterge toate cookie-urile atunci când browser-ul este închis;</li>
        <li>deschideți o sesiune "privată de navigare" / "incognito" care vă permite să navigați pe Internet fără să stocați date la nivel local;</li>
    </ul>
    <p>De asemenea puteți gestionați preferințele din setările Flash Player pentru a împiedica utilizarea cookie-urilor flash.</p>
    <p>Dacă alegeți să refuzați toate cookie-urile din browser, din păcate nu veți putea utiliza unele dintre caracteristicile și serviciile de pe site-ul noastru și unele servicii nu vor funcționa corect.</p>
    <button class="showCookieManagementButton" onClick="window.showCookieManagement()">GESTIONAȚI COOKIE-URILE</button>
</div>
`;
